// extracted by mini-css-extract-plugin
export var formContainer = "_mr-0";
export var message = "_mr-1";